module.exports = __webpack_public_path__ + "media/images/white-arrow-dropdown-5e4a6e2c85ca16650a03b4fefd68e49b.svg";